import React from 'react';
import { iconSizer } from "../../icons2022/iconSizer";
import { XIcon16Light } from "../../icons2022/XIcon/XIcon16Light";
import { XIcon20Light } from "../../icons2022/XIcon/XIcon20Light";
import { XIcon24Regular } from "../../icons2022/XIcon/XIcon24Regular";
export var CrossIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(XIcon16Light, {
      align: "none"
    });
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(XIcon20Light, {
      align: "none"
    });
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(XIcon24Regular, {
      align: "none"
    });
  }
}, 'CrossIcon');